export const AMEX_PARTNER_NAME = 'amex';
